export default {
  harassment: {
    create: {
      ingress:
        'Hier hast du die Möglichkeit, uns mehr darüber zu berichten, was du bei {organizationTitle} mit angesehen oder miterlebt hast. Wir sind dir sehr dankbar, dass du uns hilfst, die Sicherheit an unserem Arbeitsplatz zu gewährleisten.',
      instructions:
        'Schreibe deinen Bericht in das Textfeld unten. Du entscheidest, ob du in deinem Bericht deine E-Mail-Adresse angibst oder lieber anonym bleibst. Egal, ob du anonym bleibst oder nicht: Nach Einreichung deines Berichts kannst du in jedem Fall auf diesen zurückkommen und diesen nachverfolgen.',
      instructions1:
        'Du erhältst über den Bericht eine Versandbestätigung, eine Fall-ID und ein Passwort. Diese Daten kannst du benutzen, um den Fall später nachzuverfolgen, egal, ob deine Meldung anonym erfolgte oder nicht.',
      instructions2:
        'Berichte gehen bei ernannten Administratoren bei {organizationTitle} ein. Niemand anders kann den von dir geschickten Bericht lesen. Wenn du deine E-Mail-Adresse angegeben hast, wirst du im Falle eine Statusänderung des Falls benachrichtigt. Oder die Organisation kann sich mit eventuellen Fragen an dich wenden. Wir behandeln deine Identität vertraulich und legen diese nur offen, falls dies für den Fall erforderlich ist.',
      instructionsHeader: 'Wie funktioniert das?',
      options: {
        confirmNotToIncludeEmail:
          'Ich verstehe, dass ich bei Nichtangabe meiner E-Mail-Adresse auf die Möglichkeit verzichte, über Statusänderungen meines Falls benachrichtigt zu werden, und die Empfängerorganisation weiß nicht, wer ich bin.',
        includeEmail: 'Ich möchte meine E-Mail-Adresse angeben.'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Nach Versand des Berichts kannst du diesen aus Sicherheitsgründen nicht mehr lesen und auch keine Änderungen mehr vornehmen. Du kannst jedoch später darauf zurückkommen und den Fallstatus nachverfolgen,  deine eigenen Fragen oder Rückfragen von {organizationTitle} einsehen und auch anonym weitere Angaben machen.',
        confirmDescriptionEmailIncluded:
          'Da du dich entschieden hast, deine E-Mail-Adresse anzugeben, kontaktieren wir {email}, wenn der Fall eröffnet wird und falls wir Fragen an dich haben. Kontrolliere deinen nachstehenden Bericht bitte, bevor du ihn abschickst.',
        confirmDescriptionEmailNotIncluded:
          'Du hast dich entschieden, den Bericht ohne deine E-Mail-Adresse einzureichen, also können wir dich nicht kontaktieren. Kontrolliere den nachstehenden Bericht, bevor du ihn abschickst.',
        createDescription: 'Gib deine Beschreibung bitte hier an:',
        placeholder: 'Ich würde gern Folgendes berichten…',
        reporterGuide: {
          question1: 'Was ist dein Anliegen?',
          question2: 'Wann ist das geschehen?',
          question3: 'Wer war beteiligt?',
          question4: 'Wo geschah es?',
          question5: 'Hast du alle Einzelheiten angegeben?',
          question6: 'Du kannst ein Bild hinzufügen, wenn du möchtest.',
          title: 'Anleitung zum Verfassen eines Berichts'
        },
        responseDescriptionEmailIncluded:
          'Du wirst per E-Mail benachrichtigt, wenn ein Administrator den Fall eröffnet.'
      }
    },
    title: 'Bericht an {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Folge bitte einem gültigen Link, um hierher zu gelangen.'
    },
    buttons: {
      back: 'Zurückgehen',
      continue: 'Weiter',
      noOption: 'Nein',
      send: 'Bericht versenden',
      yesOption: 'Ja'
    },
    confirm: {
      title: {
        reportNotSent: 'Bericht wurde NICHT versendet!'
      }
    },
    create: {
      email: {
        help:
          'Wenn du in deinem Bericht deine E-Mail-Adresse angibst, informieren wir dich über Status-Aktualisierungen oder kontaktieren dich mit eventuellen Rückfragen. Die Angabe einer E-Mail-Adresse ist freiwillig.',
        label: 'E-Mail:',
        placeholder: 'Gib deine E-Mail-Adresse bitte hier ein'
      },
      ingress:
        'Hier kannst du Fehlverhalten melden, worüber du informiert bist oder welches du vermutest, das in {organizationTitle} aufgetreten ist oder auftreten könnte. Der Kanal soll nur benutzt werden, um Fehlverhalten in arbeitsbezogenen Situationen zu melden und nur, wenn du Grund zu der Annahme hast, dass deine Informationen wahr sind.',
      instructions:
        'Erst wählst du aus, wie du deinen Bericht hinterlassen möchtest. Du kannst auch entscheiden, ob du den Bericht unter Angabe deiner E-Mail-Adresse versenden oder lieber anonym bleiben möchtest. Egal, ob du anonym bleibst oder nicht: Nach Einreichung deines Berichts kannst du in jedem Fall auf diesen zurückkommen und diesen nachverfolgen.',
      instructions1:
        'Du erhältst dann eine Bestätigung, dass der Bericht versandt wurde, eine Fall-ID und ein Passwort. Diese Daten kannst du benutzen, egal, ob du anonym bleibst oder nicht, um den Bericht später nachzuverfolgen. Selbst wenn du dich entscheidest, eine Angelegenheit in einer physischen Begegnung oder telefonisch zu melden, kannst du den Fall auch digital nachverfolgen, falls von dir gewünscht.',
      instructions2:
        'Berichte gehen bei ernannten Administratoren bei {organizationTitle} ein. Niemand anders kann den von dir geschickten Bericht lesen. Wenn du deine E-Mail-Adresse angegeben hast, wirst du im Falle eine Statusänderung des Falls benachrichtigt. Oder die Organisation kann sich mit eventuellen Fragen an dich wenden. Wir behandeln deine Identität vertraulich und legen diese nur offen, falls dies für den Fall erforderlich ist.',
      instructionsHeader: 'Wie funktioniert das?',
      options: {
        confirmNotToIncludeEmail:
          'Ich verstehe, dass ich bei Nichtangabe meiner E-Mail-Adresse auf die Möglichkeit verzichte, über eine Statusänderung meines Falls benachrichtigt zu werden, da die Empfängerorganisation nicht weiß, wer ich bin.',
        includeEmail: 'Ich möchte meine E-Mail-Adresse angeben.'
      }
    },
    followup: {
      buttons: {
        submit: 'Fall holen'
      },
      messages: {
        buttons: {
          send: {
            help:
              'Du kannst eine Folgemeldung versenden, die von Vertretern der Empfängerorganisation gelesen wird. Niemand anders kann deine Nachricht lesen.',
            title: 'Nachricht verschicken'
          }
        },
        messageSent: 'Vielen Dank für deine Nachricht!',
        placeholder: 'Gib hier eine Nachricht ein.',
        reporter: 'Berichtende Person',
        title: 'Nachrichten',
        writtenByAdmin: 'Admin'
      },
      status: {
        new: {
          description:
            'Deine Nachricht ist eingegangen und wird in Kürze geprüft.',
          title: 'Neu'
        },
        open: {
          description:
            'Deine Nachricht ist eingegangen und wird gerade geprüft. Weitere Aktualisierungen erhältst du zu einem späteren Zeitpunkt. Wenn du deine Kontaktdaten angegeben hast, werden wir uns bei dir melden.',
          title: 'Offen'
        },
        solved: {
          description:
            'Dein Bericht wurde bearbeitet und die Untersuchung ist jetzt abgeschlossen. Wenn du deine Kontaktdaten angegeben hast, melden wir uns bei dir mit weiteren Einzelheiten.',
          title: 'Gelöst'
        }
      },
      statusLabel: 'Der Fall hat den Status:',
      title: 'Fall {caseName}'
    },
    followupLogin: {
      caseLabel: 'Fall-ID:',
      passwordLabel: 'Passwort:',
      title: 'Fall nachverfolgen'
    },
    messages: {
      error: {
        failedToSendReport: 'Der Bericht konnte nicht versandt werden.',
        organizationNotFound:
          'Wir konnten deinen Bericht an keine passende Organisation schicken. Vergewissere dich bitte, dass du über einen gültigen Link hierher gelangt bist.',
        whistleblowerInfoNotFound:
          'Es konnten keine Informationen zu Meldungen in dieser Organisation gefunden werden.'
      }
    },
    received: {
      bottomWarning:
        'Achtung! Dies ist die einzige Möglichkeit für dich, die obenstehenden Informationen einzusehen, speichere sie also jetzt ab!',
      caseLabel: 'Fall-ID:',
      linkLabel: 'Link',
      passwordLabel: 'Passwort:',
      title: 'Bericht erhalten!',
      topWarning: 'Bitte speichere die nachstehenden Informationen sicher ab!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Nach Versand des Berichts kannst du diesen aus Sicherheitsgründen nicht mehr lesen und auch keine Änderungen mehr vornehmen. Du kannst jedoch später darauf zurückkommen und den Fallstatus nachverfolgen,  deine eigenen Fragen oder Rückfragen von {organizationTitle} einsehen und auch anonym weitere Angaben machen.',
        confirmDescriptionEmailIncluded:
          'Da du dich entschieden hast, deine E-Mail-Adresse anzugeben, kontaktieren wir {email}, wenn der Fall eröffnet wird und falls wir Fragen an dich haben. Kontrolliere deinen nachstehenden Bericht bitte, bevor du ihn abschickst.',
        confirmDescriptionEmailNotIncluded:
          'Du hast dich entschieden, den Bericht ohne deine E-Mail-Adresse einzureichen, also können wir dich nicht kontaktieren. Kontrolliere den nachstehenden Bericht, bevor du ihn abschickst.',
        createDescription:
          'Beschreibe, was geschehen ist und warum du dies melden möchtest. Lass bitte persönliche Angaben weg, sofern diese für den Fall nicht wichtig sind.',
        label:
          'Ich möchte digital über dieses Formular einen Bericht einreichen.',
        placeholder: 'Ich würde gern Folgendes berichten…',
        reporterGuide: {
          question1: 'Was ist dein Anliegen?',
          question2: 'Wann ist das geschehen?',
          question3: 'Wer war beteiligt?',
          question4: 'Wo geschah es?',
          question5: 'Hast du alle Einzelheiten angegeben?',
          question6: 'Du kannst ein Bild hinzufügen, wenn du möchtest.',
          title: 'Anleitung zum Verfassen eines Berichts'
        },
        responseDescriptionEmailIncluded:
          'Du wirst per E-Mail benachrichtigt, wenn einer der Administratoren den Fall eröffnet. Dies geschieht innerhalb von 7 Tagen. Nach Eröffnung des Falles schließen wir die Untersuchung binnen 3 Monaten ab.',
        responseDescriptionEmailNotIncluded:
          'Da du dich entschieden hast, deinen Bericht anonym einzureichen, hast du keine Möglichkeit, über die Eröffnung des Falles per E-Mail benachrichtigt zu werden. Auch über weitere Aktivitäten bezüglich des Falles wirst du nicht benachrichtigt. Unter Verwendung der nachstehenden Angaben kannst du aber trotzdem Rücksprache halten und den Fallstatus nachverfolgen.',
        responseIngress:
          'Vielen Dank für deinen Bericht! Wir behandeln deinen Fall so schnell wie möglich.'
      },
      phoneCall: {
        confirmDescription:
          'Im nächsten Schritt bekommst du eine Telefonnummer angezeigt, die du anrufen kannst. Bist du dir sicher, dass du deinen Bericht telefonisch übermitteln möchtest?',
        createDescription:
          'Du bekommst die Möglichkeit, deinen Bericht als Sprachnachricht zu hinterlassen.',
        label: 'Ich möchte meinen Bericht telefonisch übermitteln.',
        message:
          '=== Die berichtende Person ruft an und hinterlässt den Bericht als Sprachnachricht. ===',
        responseDescription:
          'Um deinen Bericht zu hinterlassen, rufst du bitte die folgende Telefonnummer an und hinterlässt eine Sprachnachricht.',
        responseInstructions1: 'Rufe die vorstehende Telefonnummer an.',
        responseInstructions2:
          'Hinterlasse deinen Bericht unter Angabe möglichst vieler Einzelheiten.',
        responseInstructions3:
          'Wenn du über Änderungen des Fallstatus informiert werden oder neue Korrespondenz erhalten möchtest, dann gib in deinem Bericht bitte deine E-Mail-Adresse oder Telefonnummer an.',
        responseInstructions4:
          'Speichere die nachstehenden Informationen bitte ab, damit du sie wieder aufrufen und hier nachverfolgen kannst.',
        responseInstructionsHeader: 'Anweisungen',
        responseTitle: 'Einen Bericht telefonisch einreichen',
        responseWarning:
          'Wenn du innerhalb von 7 Tagen keine Sprachnachricht hinterlassen hast, wird dein Fall automatisch geschlossen.'
      },
      physicalMeeting: {
        confirmDescription:
          'Wir kontaktieren dich unter {email} bezüglich deiner Bitte, bei einer physischen Begegnung Bericht zu erstatten. Möchtest du fortfahren?',
        createDescription:
          'Wir bieten dir die Möglichkeit, bei einer physischen Begegnung Bericht zu erstatten. Dafür musst du eine E-Mail-Adresse angeben, über die wir dich kontaktieren, um ein Treffen einzuplanen.',
        label: 'Ich möchte bei einer physischen Begegnung Bericht erstatten.',
        message:
          '=== Die berichtende Person bat um eine physische Begegnung, um Bericht zu erstatten. ===',
        responseDescription:
          'Vielen Dank! Wir melden uns bei dir mit einem Terminvorschlag für ein physisches Treffen, bei dem du uns Bericht erstatten kannst.  Vergewissere dich bitte, dass du die folgenden Informationen speicherst. Du benötigst sie, wenn du deinen Fall nach dem Treffen weiterverfolgen möchtest.',
        responseTitle: 'Anfrage für ein physisches Treffen abgeschickt'
      }
    },
    title: 'Fehlverhalten bei {organizationTitle} melden'
  }
}
